export const saveToLocal = <T>(
  key: string,
  value: T,
  stringify = true,
  persistent = true
): void => {
  const storage = persistent ? localStorage : sessionStorage;
  const data = stringify ? JSON.stringify(value) : String(value);
  storage.setItem(key, data);
};

export const getFromLocal = <T>(
  key: string,
  parse = true,
  persistent = true
): T | null => {
  const storage = persistent ? localStorage : sessionStorage;
  const data = storage.getItem(key);
  
  if (!data) return null;
  
  if (parse) {
    try {
      return JSON.parse(data) as T;
    } catch {
      return data as T;
    }
  }
  
  return data as T;
};

export const removeFromLocal = (key: string, persistent = true): void => {
  const storage = persistent ? localStorage : sessionStorage;
  storage.removeItem(key);
};

export const clearLocalStorage = (): void => {
  localStorage.clear();
  sessionStorage.clear();
};
